/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState, useEffect} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {Link} from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
// import PopUpComponent from "../components/Nav/PopUpComponent";
import PhotoComponent from "../components/Photo/PhotoComponent";
import ReactPlayer from 'react-player/youtube'
import PhotosComponent from "../components/Photo/PhotosComponent";
// import ProductDetailComponent from "../components/Product/ProductdetailComponent";
import Sidebar from "./base/Sidebar";
import Product from "./schoolphotoservice/product";

import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
    Grid,
    Card,
    Typography,
} from "@material-ui/core";

import {
    ADD_TO_CART,
    GET_ALL_PRODUCTS_BY_PHOTO_ID,
    GET_SHOPPINGCART,
} from "./../queries";
import {withTranslation} from "react-i18next";
import {useThemeData} from "../context/ThemeDataContext";
import GeneralButton from "../components/Buttons";
import GeneralText from "../components/Fonts";

function ShopPage(props) {
    const {font_family, primary_color_2, primary_color_4, primary_color_5, background_color_3} =
        useThemeData().themeData.site.theme;
    const site_id = useThemeData().themeData.site.site_id;
    const categorie_id = props.match.params.category_id;
    const {category_id, setCategoryID} = useThemeData().categoryData;
    const {hide_category_side_bar, greenscreen_background_required} = useThemeData().modules;
    const photo_id = props.match.params.photo_id;
    const session_id = localStorage.getItem("session_id");

    const [queryVars, setQueryVars] = useState({
        logins: localStorage.getItem("login_name"),
        photo_id: photo_id,
        site_id: site_id,
        categorie_id: categorie_id
    });

    const [product_color, setProductColor] = useState("Kleur");

    const [quantity, setQuantity] = useState([]);
    const [productVariation, setProductVariation] = useState('');
    const [printType, setPrintType] = useState('Mat');
    const [effect_file_name, setEffectFileName] = useState('v_Effen_wit.jpg');
    const [effect_file_name_behind, setEffectFileNameBehind] = useState('');
    const [effect_file_name_for, setEffectFileNameFor] = useState('');
    const [effect_file_id, setEffectFileID] = useState('0');
    const [effect_file_id_behind, setEffectFileIDBehind] = useState('0');
    const [effect_file_id_for, setEffectFileIDFor] = useState('0');
    const [type_effect, setTypeEffect] = useState('');
    const loginName = localStorage.getItem("login_name");
    const firstPartLogin = loginName !== null ? loginName.replace('["', '') : ''
    const MiddelPartLogin = firstPartLogin.replaceAll('","', ', ')
    const login_name = MiddelPartLogin.replace('"]', '')
    const [isExpanded, setIsExpanded] = useState(true);  // State to manage the accordion's expanded state
    const [logins] = useState({login_name});
    const [data, setData] = useState(undefined);
    const [newData, setNewData] = useState([]);
    const [newPhotoId, setNewPhotoId] = useState(null);
    const shippingMethod = localStorage.hasOwnProperty("shippingMethod")
        ? localStorage.getItem("shippingMethod")
        : '';

    const [
        createShoppingcart,
        {loading: loadingCreateShoppingCart, error: errorCreateShoppingCart},
    ] = useMutation(ADD_TO_CART, {
        // onCompleted: onCompleted,
        onCompleted: (data) => {
            if (data.createShoppingcart.message !== null) {
                alert(data.createShoppingcart.message);
            }
            setEffectFileName('v_Effen_wit.jpg');
            setEffectFileNameBehind('');
            setEffectFileNameFor('');
            setEffectFileID('0');
        },
        onError: (error) => {

        },
        refetchQueries: [
            {
                query: GET_SHOPPINGCART,
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    login_name: [logins],
                    shipping_method: shippingMethod
                },
            },
        ],
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
    });

    const {
        loading: loadingProducts,
        error: errorProducts,
        data: dataProducts,
    } = useQuery(GET_ALL_PRODUCTS_BY_PHOTO_ID, {
        variables: {
            photo_id: queryVars.photo_id,
            site_id: site_id,
            login_name: login_name,
        },
        skip:
            photo_id === undefined ||
            (data !== undefined && data.photo.id === photo_id) ||
            site_id === undefined ||
            queryVars.logins === undefined,
    });

    useEffect(() => {
        /* als je naar volgende vorige pagina gaat moet hij de data opnieuw laden */
        if (data === undefined) {
            if (!loadingProducts && !errorProducts && dataProducts) {
                setData(dataProducts);
            }
        }
    }, [dataProducts, errorProducts, loadingProducts, data, photo_id]);

    useEffect(() => {
        /* als je naar volgende vorige pagina gaat moet hij de data opnieuw laden */
        if (data !== undefined) {
            if (data.photo.id !== queryVars.photo_id) {
                setNewPhotoId(null);
                if (!loadingProducts && !errorProducts && dataProducts) {
                    setData(dataProducts);

                }
            }
        }
    }, [dataProducts, errorProducts, loadingProducts, data, photo_id, queryVars.photo_id, props]);

    useEffect(() => {
        if (photo_id !== queryVars.photo_id) {
            setQueryVars((prevState) => ({...prevState, photo_id: photo_id, categorie_id: categorie_id}));
        }
    }, [photo_id, queryVars.photo_id, categorie_id, queryVars.categorie_id]);

    const updatePhotoFileName = (newPhotoFileName, productId, productChildId, newPhotoId, i) => {
        let newProduct = new Set(); //pakketdetails

        newData.map((item, indexId) => {


            let filename = "";
            let photoId = "";

            if (item.products.parent_product_id === productId && item.products.product_id === productChildId) {

                // if (i === indexId) {
                photoId = newPhotoId;
                filename = newPhotoFileName;
                // } else {
                //  photoId = item.products.productdetail.photo_id;
                //   filename = item.products.productdetail.product_file;
                // }

            } else {
                photoId = item.products.productdetail.photo_id;
                filename = item.products.productdetail.product_file;
            }

            let data_array = {
                photo_id: photoId,
                products: {
                    product_id: item.products.product_id,
                    parent_product_id: item.products.parent_product_id,
                    productdetail: {
                        product_file: filename,
                        naam: item.products.productdetail.naam,
                        product_format: item.products.productdetail.product_format,
                        actie_prijs: item.products.productdetail.actie_prijs,
                        prijs: item.products.productdetail.prijs,
                        product_name: item.products.productdetail.naam,
                        product_categorie: item.products.productdetail.product_categorie,
                        totaalprijs: item.products.productdetail.actie_prijs,
                        oorspronkelijke_prijs_ps: item.products.productdetail.prijs,
                        prijs_ps: item.products.productdetail.actie_prijs,
                        photo_id: photoId,
                        // product_type: item.products.productdetail.product_type,
                        combivel_id: item.products.productdetail.combivel_id,
                        shippingcost: item.products.productdetail.verzendkosten,
                        product_type: item.products.productdetail.product_type,
                        kleuren: item.products.productdetail.kleuren,
                        // afbeelding: item.products.productdetail.afbeelding,
                        // youtube: item.products.productdetail.youtube,
                        // description: item.products.productdetail.description,
                        // type: item.products.productdetail.type,
                        // actie_afbeelding: item.products.productdetail.actie_afbeelding,
                        // actie_begin_datum: item.products.productdetail.actie_begin_datum,
                        // actie_eind_datum: item.products.productdetail.actie_eind_datum,
                        // quantum_aantal: item.products.productdetail.quantum_aantal,
                        // quantum_perc: item.products.productdetail.quantum_perc,
                    },
                },
            };

            return newProduct.add(data_array);
            // }
        });
        let products = Array.from(newProduct);
        setNewData(products);
    };

    useEffect(() => {
        //  if (newData.length === 0) {
        // only set pakketdetails when is not set yet
        let newProduct = new Set();
        if (data !== undefined) {
            if (data.photo.folder.productlist.products.length > 0) {
                data.photo.folder.productlist.products.map((product) => {
                    product.productlink.productpakketdetails[0].products.map(
                        (item, indexId) => {
                            var fileNameSplit = item.productdetail.product_file.split(".");
                            if (fileNameSplit[1] !== "png") {
                                setEffectFileName('');
                            }


                            let data_array = {
                                photo_id: item.productdetail.photo_id,
                                products: {
                                    parent_product_id: product.product_id,
                                    product_id: item.product_id,
                                    productdetail: {
                                        product_file: item.productdetail.product_file,
                                        naam: item.productdetail.naam,
                                        photo_id: item.productdetail.photo_id,
                                        product_format: item.productdetail.product_format,
                                        actie_prijs: item.productdetail.actie_prijs,
                                        verzendkosten: item.productdetail.verzendkosten,
                                        prijs: item.productdetail.prijs,
                                        combivel_id: item.productdetail.combivel_id,
                                        product_name: item.productdetail.naam,
                                        product_categorie: item.productdetail.productcategory.naam,
                                        product_type: item.productdetail.product_type,
                                        totaalprijs: item.productdetail.actie_prijs,
                                        oorspronkelijke_prijs_ps: item.productdetail.prijs,
                                        prijs_ps: item.productdetail.actie_prijs,
                                        kleuren: item.productdetail.kleuren,
                                        school_id: data.photo.school_id
                                    },
                                },
                            };
                            return newProduct.add(data_array);
                        }
                    );
                    return newProduct;
                });
            }
        }

        let products = Array.from(newProduct);


        setNewData(products);
        //  }
    }, [newData.length, data, photo_id]);

    useEffect(() => {
        if (data !== undefined && newData.length > 0) {
            if (queryVars.photo_id !== data.photo.id) {
                if (newPhotoId !== null) {

                    // only set if newData is not matching current data
                    let newProduct = new Set();
                    if (data.photo.folder.productlist.products.length > 0) {
                        data.photo.folder.productlist.products.map((product) => {
                            product.productlink.productpakketdetails[0].products.map(
                                (item, indexId) => {

                                    var fileNameSplit = item.productdetail.product_file.split(".");
                                    if (fileNameSplit[1] !== "png") {
                                        setEffectFileName('');
                                    }

                                    let data_array = {
                                        photo_id: item.productdetail.photo_id,
                                        products: {
                                            parent_product_id: product.product_id,
                                            product_id: item.product_id,
                                            productdetail: {
                                                product_file: item.productdetail.product_file,
                                                photo_id: item.productdetail.photo_id,
                                                combivel_id: item.productdetail.combivel_id,
                                                naam: item.productdetail.naam,
                                                product_format: item.productdetail.product_format,
                                                actie_prijs: item.productdetail.actie_prijs,
                                                verzendkosten: item.productdetail.verzendkosten,
                                                prijs: item.productdetail.prijs,
                                                product_name: item.productdetail.naam,
                                                product_categorie: item.productdetail.productcategory.naam,
                                                product_type: item.productdetail.product_type,
                                                totaalprijs: item.productdetail.actie_prijs,
                                                oorspronkelijke_prijs_ps: item.productdetail.prijs,
                                                prijs_ps: item.productdetail.actie_prijs,
                                                kleuren: item.productdetail.kleuren,
                                                school_id: data.photo.school_id
                                            },
                                        },
                                    };
                                    return newProduct.add(data_array);
                                }
                            );
                            return newProduct;
                        });
                    }
                    let products = Array.from(newProduct);
                    setNewData(products);
                    setNewPhotoId(queryVars.photo_id);
                }
            }
        }
    }, [newData, data, photo_id, queryVars, newPhotoId]);

    const handlerFileNameEffect = (effectFileName) => {
        setEffectFileName(effectFileName);
    };

    const handlerFileIdEffect = (effectFileID) => {
        setEffectFileID(effectFileID);
    };

    const handlerTypeEffect = (typeEffect) => {
        setTypeEffect(typeEffect);
    };

    /*set if type_effect is for setEffectFileNameFor and setEffectFileIdFor */
    useEffect(() => {
        if(type_effect==='voor'){
            setEffectFileNameFor(effect_file_name);
            setEffectFileIDFor(effect_file_id);
        }else{
            setEffectFileNameBehind(effect_file_name);
            setEffectFileIDBehind(effect_file_id);
        }
    }, [effect_file_name, effect_file_id, type_effect]);

    const handleEffectClear = (e)  => {
        setEffectFileNameFor('');
        setEffectFileIDFor('0');
        setEffectFileNameBehind('');
        setEffectFileIDBehind('0');
    }

    const changeQuantity = (quantity_data) => {
        setQuantity(quantity_data);
    };

    const handlerProductVariation = (productVariation_data) => {
        // Check if the object is empty
        if (Object.keys(productVariation_data).length === 0) {
         //   setProductVariation(''); // Set to empty string if no product variations
        } else {
            setProductVariation(JSON.stringify(productVariation_data)); // Else stringify the data
        }
    }

    const handlePrintType = (printTypeName) => {
        setPrintType(printTypeName);
    }

    const handleColorChange = (event) => {
        setProductColor(event.target.value);
    };

    const closePopup = () => {
        // setMessage(false);
    };

    const handleCreateShoppingCart = (e, product) => {
        e.preventDefault();
        e.stopPropagation();

        if (!loadingCreateShoppingCart && !errorCreateShoppingCart) {
            if (!localStorage.hasOwnProperty("cart_session_id")) {
                let generateRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
                localStorage.setItem(
                    "cart_session_id",
                    generateRandomNumber(500, 100000)
                );
            }
            const cart_session_id = localStorage.getItem("cart_session_id");

            // let i = 0;
            let dataSubProducts = newData.map((item, indexId) => {
                if (item.products.parent_product_id === product.product_id) {
                    const colors = item.products.productdetail.kleuren !== null && item.products.productdetail.kleuren !== '' && item.products.productdetail.kleuren !== undefined ? item.products.productdetail.kleuren.split(";") : null;
                    let color = 'Kleur';
                    if (colors !== null) {
                        if (colors.includes(product_color)) {
                            color = product_color;
                        } else if (colors.length >= 1) {
                            color = colors[0];
                        }
                    }

                    const container = {
                        cart_session_id: cart_session_id,
                        session_id: session_id,
                        product_id: item.products.product_id,
                        product_name: item.products.productdetail.naam,
                        product_file: item.products.productdetail.product_file,
                        product_format: item.products.productdetail.product_format,
                        product_categorie: item.products.productdetail.product_categorie,
                        product_type: item.products.productdetail.product_type,
                        totaalprijs: item.products.productdetail.actie_prijs,
                        oorspronkelijke_prijs_ps: item.products.productdetail.prijs,
                        prijs_ps: item.products.productdetail.actie_prijs,
                        combivel_id: item.products.productdetail.combivel_id,
                        effect_file_name: effect_file_name_behind,
                        effect_file_id: effect_file_id_behind,
                        effect_file_name_for: effect_file_name_for,
                        effect_file_id_for: effect_file_id_for,
                        print_type: printType,
                        photo_id: item.products.productdetail.photo_id,
                        school_id: data.photo.school_id,
                        image_effect: color,
                        product_variation: productVariation,
                        amount:
                            quantity.find((q) => q.product_id === product.product_id) !==
                            undefined
                                ? quantity.find((q) => q.product_id === product.product_id)
                                    .quantity_value
                                : 1,
                    };
                    return container;
                } else {
                    return undefined;
                }
            });

            let array = !dataSubProducts ? [] : dataSubProducts.filter((f) => f !== undefined);
            var fileNameSplit = product.productdetail.product_file.split(".");
            if (fileNameSplit[1] !== "png") {
                setEffectFileName('');
            } else {
                if (greenscreen_background_required === 'true' && product.productdetail.product_type !== 'divers' && product.productdetail.effects.length !== 0) {
                    if (effect_file_name === 'v_Effen_wit.jpg' || effect_file_name === '') {
                        alert('Je bent vergeten een achtergrond te selecteren');

                        return null;
                    }
                }
            }

            const newArray = [
                {
                    product_id: product.product_id,
                    product_name: product.productdetail.naam,
                    product_file: product.productdetail.product_file,
                    product_format: product.productdetail.product_format,
                    product_categorie: product.productdetail.productcategory.naam,
                    shippingcost: product.productdetail.verzendkosten,
                    photo_id: photo_id,
                    effect_file_name: effect_file_name_behind,
                    effect_file_name_for: effect_file_name_for,
                    effect_file_id: effect_file_id_behind,
                    effect_file_id_for: effect_file_id_for,
                    print_type: printType,
                    totaalprijs: product.productdetail.actie_prijs,
                    oorspronkelijke_prijs_ps: product.productdetail.prijs,
                    prijs_ps: product.productdetail.actie_prijs,
                    combivel_id: product.productdetail.combivel_id,
                    product_type: product.productdetail.product_type,
                    session_id: session_id,
                    site_id: site_id,
                    login_name: logins,
                    school_id: data.photo.school_id,
                    image_effect: product_color,
                    product_variation: productVariation,
                    amount:
                        quantity.find((q) => q.product_id === product.product_id) !==
                        undefined
                            ? quantity.find((q) => q.product_id === product.product_id)
                                .quantity_value
                            : 1,
                    shoppingcart_rules:
                        product.productdetail.product_type === "pakket" ? array : [],
                },
            ];

            createShoppingcart({
                variables: {
                    input: newArray,
                }
            });

            setProductColor("Kleur");
            setProductVariation('');
            setEffectFileNameFor('');
            setPrintType('Mat');
            if (fileNameSplit[1] === "png") {
                setEffectFileName('v_Effen_wit.jpg');
            }

            if (product.productdetail.productcategory.next_categorie !== null && hide_category_side_bar !== 'false') {
                if (product.productdetail.productcategory.next_categorie === product.productdetail.productcategory.categorie_id) {
                    props.history.push({
                        pathname: `/cart`,
                    });
                }else {
                    props.history.push({
                        pathname: `/shoppage/photo_id/${product.productdetail.photo_id}/${product.productdetail.productcategory.next_categorie}`,
                        state: {
                            photo_id: product.productdetail.photo_id,
                            folder_id: product.productdetail.folder_id,
                            photo_file_name: product.productdetail.product_file,
                            categorie_id: product.productdetail.productcategory.next_categorie,
                        },
                    });
                }
            }

        }
    };

    useEffect(() => {
        if (categorie_id === "adds") {
            setCategoryID("adds");
        } else if (categorie_id === undefined) {
            setCategoryID(category_id);
        } else if (categorie_id !== category_id) {
            setCategoryID(categorie_id);
        } else {
            setCategoryID(category_id);
        }

    }, [categorie_id, category_id, setCategoryID]);
    if (loadingProducts) return <p>{props.t("Loading...")}</p>;
    if (errorProducts || errorCreateShoppingCart)
        return <p>{props.t("Looks like we have a problem...")}</p>;
    if (!data) return null;

    let category_id_url = category_id;
    if (categorie_id !== undefined) {
        category_id_url = categorie_id;
    } else {
        category_id_url = category_id;
    }

    let photos_col = 4;
    let product_col = 5;
    if (hide_category_side_bar === 'true') {
        photos_col = 12;
        product_col = 12;
    }
    return (
        <Grid
            item
            className="shoppage"
            style={{
                fontFamily: `${font_family}`,
                color: `${primary_color_2}`,
            }}
        >
            <Grid container direction="row">
                <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
                <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                    <GeneralText
                        className="text-center margin-around"
                        variant="h3"
                        gutterBottom={true}
                    >
                        {/*{props.t("shoppage:Shop")}*/}
                    </GeneralText>
                </Grid>
                <Grid item xl={5} lg={5} md={5} sm={12} xs={12}></Grid>
            </Grid>
            <Grid container direction="row" spacing={3}>
                {hide_category_side_bar !== 'true' && (
                    <Grid item xl={3} lg={3} md={12} sm={12} xs={12} id="sidebar">
                        <Sidebar
                            className="sticky-state"
                            keuzeset_id={props.keuzeset_id}
                            categoryData={data.photo.productcategory}
                            folder_id={
                                data.photo.folder.folder_id
                                    ? data.photo.folder.folder_id
                                    : props.location.state.folder_id
                            }
                            photo_file_name={
                                data.photo.file_name
                                    ? data.photo.file_name
                                    : props.location.state.photo_file_name
                            }
                            photo_id={
                                props.match.params.photo_id
                                    ? props.match.params.photo_id
                                    : props.location.state.photo_id
                            }
                            historyShop={props.history}
                        />
                    </Grid>)}
                <Grid item xl={photos_col} lg={photos_col} md={6} sm={12} xs={12} className="Photo-col" id="photo-col">
                    <div
                        // style={{ zIndex: "1000" }}
                        className="sticky-state"
                    >
                        {data.photo.productcategory[0].video !== '' && data.photo.productcategory[0].video !== null &&
                            // <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
                            //       style={{marginBottom: '15px'}}
                            //       container
                            //       justify="center"
                            //       alignItems="center"
                            // >
                            <div className='player-wrapper'
                                 style={{
                                     top: '-70px',
                                     position: 'relative',
                                     paddingTop: '56.25%' /* Player ratio: 100 / (1280 / 720) */
                                 }}
                            >
                                <ReactPlayer playing  muted={true} url={`${data.photo.productcategory[0].video}`} width='100%' height='100%'
                                             style={{
                                                 position: 'absolute',
                                                 top: '0' /* Player ratio: 100 / (1280 / 720) */
                                             }}
                                />
                            </div>
                        }

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
                              style={{
                                  marginBottom: '15px'
                              }}
                        >
                            <GeneralText
                                className="sidebar-title"
                                variant="h6"
                                style={{
                                    color: `${primary_color_5}`
                                }}
                            >
                                {props.t("shoppage:Choose your photo")}
                            </GeneralText>
                        </Grid>
                        {hide_category_side_bar !== 'true' && (<>
                        <div className="navigation">
                            {data.photo.previous_id !== null ? (
                                <GeneralButton
                                    component={Link}
                                    to={`/shoppage/photo_id/${data.photo.previous_id}/${category_id_url}`}
                                    name="previous"
                                    className="btn btn-secondary previous"
                                    startIcon={<ArrowBack color="inherit"/>}
                                >
                                    {props.t("shoppage:Previous")}
                                </GeneralButton>) : (<GeneralButton
                                component={Link}
                                name="previous"
                                className="btn btn-secondary previous"
                                startIcon={<ArrowBack color="inherit"/>}
                            >
                                {props.t("shoppage:Previous")}
                            </GeneralButton>)}
                            <GeneralButton
                                component={Link}
                                to={`/`}
                                name="overview"
                                className="btn btn-secondary"
                            >
                                {props.t("shoppage:Overview")}
                            </GeneralButton>
                            {data.photo.next_id !== null ? (
                                <GeneralButton
                                    component={Link}
                                    to={`/shoppage/photo_id/${data.photo.next_id}/${category_id_url}`}
                                    name="overview"
                                    className="btn btn-secondary next"
                                    endIcon={<ArrowForward color="inherit"/>}
                                >
                                    {props.t("shoppage:Next")}
                                </GeneralButton>) : (<GeneralButton
                                component={Link}
                                name="overview"
                                className="btn btn-secondary next"
                                endIcon={<ArrowForward color="inherit"/>}
                            >
                                {props.t("shoppage:Next")}
                            </GeneralButton>)}
                        </div>

                        <PhotoComponent
                            user_id={props.user_id}
                            photo_id={queryVars.photo_id}
                            folder_id={data.photo.folder.folder_id}
                            effect_file_name={null}
                            product_color={this}
                            class_id={data.photo.class_id}
                            photo_file_name={data.photo.file_name}
                            login_name={data.photo.login_name}
                            type={0}
                            headPhotoType={1}
                        />

                        <PhotosComponent
                            {...props}
                            highlight={false}
                            login_name={data.photo.login_name}
                            thumbnail={true}
                            effect_file_name={null}
                        />
                        </>)}
                    </div>
                </Grid>
                <Grid
                    item
                    xl={product_col}
                    lg={product_col}
                    md={6}
                    sm={12}
                    xs={12}
                    className="Products top-card"
                    id="Products"
                >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
                          style={{
                              marginBottom: '15px'
                          }}
                    >
                        <GeneralText
                            className="sidebar-title"
                            variant="h6"
                            style={{
                                color: `${primary_color_5}`
                            }}
                        >
                            {props.t("shoppage:Choose your product")}
                        </GeneralText>
                    </Grid>
                    <form>
                        {data.photo.folder.school_verzendkosten_korting_tekst !== '' ? (
                            <Grid container direction="row">
                                <Card className="bg-light bottom-card welcome-text">
                                    <Grid container direction="row">
                                        <Accordion
                                            expanded={isExpanded}
                                            onChange={() => setIsExpanded(prev => !prev)} // Toggle the expanded state
                                            className="card-header col-12 text-start infoAccordion"
                                        >
                                            <AccordionSummary
                                                style={{
                                                    backgroundColor: `${background_color_3}`,
                                                    color: `${primary_color_4}`,
                                                }}
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography className="font-bold">
                                                    {data.photo.folder.school_folder_naam}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography variant="body1" component="div">
                                                    {ReactHtmlParser(
                                                        data.photo.folder.school_verzendkosten_korting_tekst.replace(/\n/g, '<br/>')
                                                    )}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                </Card>
                            </Grid>
                        ) : null}

                        {data.photo.folder.productlist.products.map((product, i) => {
                            if (props.history.location.state !== undefined) {

                                if (props.history.location.state.state !== undefined) {
                                    return (
                                        product.product_id ===
                                        props.history.location.state.state.product_id && (
                                            <Product
                                                {...props}
                                                type="one_product"
                                                data={data}
                                                product={product}
                                                user_id={data.photo.user_id}
                                                login_name={data.photo.login_name}
                                                class_id={data.photo.class_id}
                                                session_id={session_id}
                                                queryVars={queryVars}
                                                quantity={quantity}
                                                changeQuantity={changeQuantity}
                                                productVariation={handlerProductVariation}
                                                printType={handlePrintType}
                                                handleColorChange={handleColorChange}
                                                closePopup={closePopup}
                                                updatePhotoFileName={updatePhotoFileName}
                                                handlerFileNameEffect={handlerFileNameEffect}
                                                handlerFileIdEffect={handlerFileIdEffect}
                                                handlerTypeEffect={handlerTypeEffect}
                                                handleCreateShoppingCart={handleCreateShoppingCart}
                                                effectFileNameFor={effect_file_name_for}
                                                effectFileNameBehind={effect_file_name_behind}
                                                effectClear={handleEffectClear}
                                            />
                                        )
                                    );
                                } else {
                                    return (
                                        <Product
                                            key={product.product_id}
                                            {...props}
                                            data={data}
                                            product={product}
                                            session_id={session_id}
                                            user_id={data.photo.user_id}
                                            login_name={data.photo.login_name}
                                            class_id={data.photo.class_id}
                                            queryVars={queryVars}
                                            quantity={quantity}
                                            changeQuantity={changeQuantity}
                                            productVariation={handlerProductVariation}
                                            printType={handlePrintType}
                                            handleColorChange={handleColorChange}
                                            closePopup={closePopup}
                                            updatePhotoFileName={updatePhotoFileName}
                                            handlerFileNameEffect={handlerFileNameEffect}
                                            handlerFileIdEffect={handlerFileIdEffect}
                                            handlerTypeEffect={handlerTypeEffect}
                                            handleCreateShoppingCart={handleCreateShoppingCart}
                                            effectFileNameFor={effect_file_name_for}
                                            effectFileNameBehind={effect_file_name_behind}
                                            effectClear={handleEffectClear}
                                        />
                                    );
                                }
                            } else {
                                return (
                                    <Product
                                        key={product.product_id}
                                        {...props}
                                        data={data}
                                        product={product}
                                        session_id={session_id}
                                        user_id={data.photo.user_id}
                                        login_name={data.photo.login_name}
                                        class_id={data.photo.class_id}
                                        queryVars={queryVars}
                                        quantity={quantity}
                                        changeQuantity={changeQuantity}
                                        productVariation={handlerProductVariation}
                                        printType={handlePrintType}
                                        handleColorChange={handleColorChange}
                                        closePopup={closePopup}
                                        updatePhotoFileName={updatePhotoFileName}
                                        handlerFileNameEffect={handlerFileNameEffect}
                                        handlerFileIdEffect={handlerFileIdEffect}
                                        handlerTypeEffect={handlerTypeEffect}
                                        handleCreateShoppingCart={handleCreateShoppingCart}
                                        effectFileNameFor={effect_file_name_for}
                                        effectFileNameBehind={effect_file_name_behind}
                                        effectClear={handleEffectClear}
                                    />
                                );
                            }
                        })}
                    </form>
                </Grid>
            </Grid>
            <Grid>
                {hide_category_side_bar === 'true' && (
                    <Grid container direction="row" alignItems="center" spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
                              style={{
                                  marginBottom: '15px'
                              }}
                        >
                            <PhotosComponent
                                {...props}
                                highlight={false}
                                login_name={data.photo.login_name}
                                thumbnail={true}
                                effect_file_name={null}
                            />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}

export default React.memo(
    withTranslation(["message", "shoppage", "shoppingcart"])(ShopPage)
);
